import React from 'react'
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

const Product = ({product, onAddToCart}) => {
  const url = (product.image===null 
    ? 'https://www.firstbenefits.org/wp-content/uploads/2017/10/placeholder.png'
    : product.image.url);


  return (
    <Card className='mb-3'>
    <div style={{ height: '250px', overflow: 'hidden' }}>
            <Card.Img src={url} style={{ height: '100%', objectFit: 'cover' }} />
        </div>
    <Card.Body>
      <Card.Title>{product.name} (${product.price.raw})</Card.Title>
      <Card.Text dangerouslySetInnerHTML={{__html: product.description}}/>
      <Button variant="primary" onClick={() => onAddToCart(product.id, 1)}>Add to Cart</Button>
    </Card.Body>
  </Card>
  );
}

export default Product;
